// Convert #RRGGBB to [r, g, b] so we can interpolate
export function parseHexToRgb(hex: string): [number, number, number] {
  let c = hex.replace('#', '');
  if (c.length === 3) {
    // short hex #fff -> #ffffff
    c = c
      .split('')
      .map((ch) => ch + ch)
      .join('');
  }
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  return [r, g, b];
}

// Map theme colors to hex values
export const COLOR_MAP: Record<string, string> = {
  'indigo-800': '#2a0d5d',
  'indigo-500': '#442aaa',
  'indigo-100': '#f3f2ff',
  'mint-800': '#006b68',
  'mint-300': '#80ffcc',
  'mint-100': '#d4f4f2',
  'coral-100': '#ECDCD8',
  'grey-50': '#F2F2F2',
  'grey-100': '#EBEBEB',
  white: '#FFFFFF',
};

// Lerp between two [r, g, b] color arrays
export function interpolateRgb(
  [rA, gA, bA]: [number, number, number],
  [rB, gB, bB]: [number, number, number],
  t: number
): [number, number, number] {
  return [rA + (rB - rA) * t, gA + (gB - gA) * t, bA + (bB - bA) * t];
}
